import React, { useCallback, useEffect, useRef, useState } from 'react'
import {SendMailModalProps} from './SendMailModal.props'
import './SendMailModal.styles.css';
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Grid from "@mui/material/Grid";
import {AlertMessage} from "../../atoms/AlertMessage";
import { TagInput, TagInputTypes } from "../../atoms/TagInput";
import {Editor} from "../../molecules/Editor";
import {MESSAGES_INFECTED_SENDMAIL, TEMPLATE_TOKENS} from "../../../constants/contants";
import InputAdornment from "@mui/material/InputAdornment";
import { FromInputMail } from "../../molecules/FromInputMail/FromInputMail";
import Select from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { Dialog, Stack, Typography } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import WarningIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { getListEmailTemplate } from "../../../api/emailTriage";
import Box from "@mui/material/Box";
import { Jodit } from 'jodit-react';
import { Images } from "../../../configs/images";
import { SearchFilter } from "../../molecules/SearchFilter";
import TokenTag from "../../atoms/TokenTag/TokenTag";
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { insertTextAtCursor } from "../../../utils/common";
import { useTranslation } from "react-i18next";
import {useRoleContext} from "../../../context/RoleContext";
import {classifyThreatScore} from "../../../utils/threatScore";

const TEMPLATES_FILTER_ENABLE_LENGTH = 7;
export const NO_TEMPLATE_VALUE = 'no_template';

export const SendMailModal: React.FC<SendMailModalProps> = ({
    defaultParams,
    paramSendMail,
    setParamSendMail,
    scanResult,
    /* istanbul ignore next */
    // isHiddenAttachedAndStatus = false,
    /* istanbul ignore next */
    isFromName = false,
    defaultContent,
    /* istanbul ignore next */
    // isShowAttachedDefault = false,
    /* istanbul ignore next */
    attachedLabel = '',
    checkboxInputCC = true,
    subjectPrefix = '',
    isHiddenToCC = false,
    validateFromName= false,
    setValidateFromName,
    fromNameError,
    editorError,
    validateToField,
    setValidateToField,
    validateEmailContent,
    setValidateEmailContent,
    validateUserName,
    setValidateUserName,
    validateBaseSender,
    setValidateBaseSender,
    lineBelowContent,
    isTestDomain,
    testDomainName,
    useTemplates = false,
}) => {
    const { t } = useTranslation();
    const [editorText, setEditorText] = useState<string>(() => {
        if (paramSendMail && paramSendMail[ 'email_content' ]) {
            return paramSendMail[ 'email_content' ];
        }
        return '';
    });
    const [templateSelection, setTemplateSelection] = useState(NO_TEMPLATE_VALUE);
    const [templates, setTemplates] = useState([]);
    const [templateChangeConfirmation, setTemplateChangeConfirmation] = useState(false);
    const [nextTemplateSelection, setNextTemplateSelection] = useState('');
    const [loadingEditor, setLoadingEditor] = useState(false)
    const [templateEditorError, setTemplateEditorError] = useState(false);
    const [isDisable, setIsDisable] = useState<boolean>(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [tags, setTags] = useState({ to: [] as string[], cc: [] as string[] });
    const [tagInputValues, setTagInputValues] = useState({ to: '', cc: '' });
    const [joditInstance, setJoditInstance] = useState<Jodit | undefined>();
    const [filterSearchKeyword, setFilterSearchKeyword] = useState('');
    const [filteredTemplates, setFilteredTemplates] = useState([]);
    const [templateModified, setTemplateModified] = useState(false);

    const subjectRef: any = useRef();
    const [subjectValue, setSubjectValue] = useState('');

    // @ts-ignore
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : /* istanbul ignore next */{};
    const defaultData: any = {
        subject: defaultParams.subject || /* istanbul ignore next */'',
        from: userData.email,
        fromName: userData.fullName,
        to: [],
        cc: [],
        originalReporter: true,
        statusToResolved: true,
        content: '',
        base64Data: '',
        originalEmail: '',
        recipients: [],
        reportedBy: defaultParams.reportedBy
    }
    const tagRefTo: any = useRef();
    const tagRefCC: any = useRef();
    const selectedTemplateIndex = templates.findIndex(template => template['id'] === templateSelection);
    const selectedTemplate = templates.filter(template => template?.['id'] === templateSelection || (template?.['name'] as string).indexOf(filterSearchKeyword) !== -1);

    const tokens = [
      {
        content: TEMPLATE_TOKENS.DOWNLOAD_REPORTED_EMAIL,
        tooltip: 'When the email is sent, it will appear as a link that users can click on it to download the reported email.',
        expandable: false,
      },
      {
        content: TEMPLATE_TOKENS.SENDER,
        tooltip: 'When click or typing, it will appear as the email of the person who reported the email.',
        expandable: true,
      },
      {
        content: TEMPLATE_TOKENS.STATUS,
        tooltip: <div id="status-token-tooltip">When click or typing, it will appear as the final status of the email:
          <ul>
            <li>"No Threat"</li>
            <li>"Threat Identified" (Threat/Undetermined).</li>
          </ul>
        </div>,
        expandable: true,
      },
      {
        content: TEMPLATE_TOKENS.REPORTED_EMAIL_SUBJECT,
        tooltip: 'When click or typing, it will appear  as the Email subject of the reported email.',
        expandable: true,
      },
    ];

    const isActiveElement = (element: Element) => element === document.activeElement;

    const validateField = (value: string, type?: string) => {
      /* istanbul ignore next */
      if (!value || !value?.replace(/<\/?[^>]+(>|$)/g, "")) {
            setTemplateEditorError(true);
        } else {
            setTemplateEditorError(false);
        }
    }

    const applyTokens = (input = ''): string => {
        const classification = classifyThreatScore(Number(defaultParams?.threat_score ?? -1))
        const tokenStatusValue = classification.category === 'Clean'
          ? 'No Threat'
          : classification.category === 'Threat'
            ? 'Threat Identified'
            : classification.category

        const values: Record<string, string> = {
            sender: defaultParams?.reportedBy || "",
            reported_email_subject: defaultParams?.subject || "",
            status: tokenStatusValue,
            reporter_email: defaultParams?.reportedBy || "",
        };

        const re = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;

        return input?.replace(re, (_, key: string) => {
            if (Object.prototype.hasOwnProperty.call(values, key)) {
                return values[key] ?? "";
            }
            return `{{${key}}}`;
        });
    }

    const hasTemplateBeenModified = () => {
      const {
        content,
        to,
        cc,
        subject: templateSubject
      } = templates[selectedTemplateIndex] || {};
      const trim = (str: any) => String(str).replace(/(,$)/g, "");
      const templateTo = applyTokens(trim(to));
      const templateCC = applyTokens(trim(cc));
      const currentTo = applyTokens(trim(tags.to.join(',')));
      const currentCC = applyTokens(trim(tags.cc.join(',')));

      return (selectedTemplateIndex === -1) ? !!editorText || !!tags.to.length || !!tags.cc.length || !!subjectValue
        : editorText !== applyTokens(content) || currentTo !== templateTo || currentCC !== templateCC || subjectValue !== applyTokens(templateSubject);
    }

    useEffect(() => {
      if (useTemplates) {
        getListEmailTemplate({
          "action": "list",
          "payload": {
            "filters": { "status": ["active"] }
          }
        }).then((res: any) => {
          if (res && res.status === 200) {
            setTemplates(res.data?.list)
            setLoadingEditor(false)
          }
        }).catch(err => {
          console.log("err: ", err)
          setLoadingEditor(false)
        });
      } else {
          setTags({
              "to": paramSendMail?.to || [],
              "cc": paramSendMail?.cc || [],
          })
      }
    }, []);

    // @ts-ignore
    useEffect(() => {
        setParamSendMail({
            ...paramSendMail,
            email_content: editorText,
        });
        if (!useTemplates || templateSelection !== NO_TEMPLATE_VALUE) {
          validateField(editorText);
        }
    }, [editorText]);

    useEffect(() => {
      if (!filterSearchKeyword) {
          setFilteredTemplates(templates);
      }
    }, [templates, filterSearchKeyword]);

    const handleTemplateChange = (e: any, type: any) => {
        const target = e.target as HTMLInputElement;
        let val: any = target.value;

        if (type === "originalReporter") val = target.checked;
        else if (type === "subject") val = applyTokens(String(val));
        else if (type === "cc" || type === "to") {
            const arr = applyTokens(String(val)).split(",").map(s => s.trim()).filter(Boolean);
            setTags((prev: any) => ({ ...prev, [type === "cc" ? "cc" : "to"] : arr }));
            val = arr;
        }

        setParamSendMail((prev: any) => ({ ...prev, [type]: val }));

        if (type === "fromName" && setValidateFromName && !String(val ?? "").trim()) {
            setValidateFromName(true);
        }
    }

    useEffect(() => {
        if (useTemplates) {
            if (selectedTemplateIndex > -1) {
                const template = filteredTemplates[selectedTemplateIndex];
                setEditorText(applyTokens(template?.['content']));
                handleTemplateChange({ target: { value: applyTokens(template?.['to']) || '' } }, 'to');
                handleTemplateChange({ target: { value: applyTokens(template?.['cc']) || '' } }, 'cc');
                handleTemplateChange({ target: { value: applyTokens(template?.['subject']) || '' } }, 'subject');
                setSubjectValue(applyTokens(template?.['subject']) || '');
            } else {
                setEditorText('');
                handleTemplateChange({ target: { value: '' } }, 'to');
                handleTemplateChange({ target: { value: '' } }, 'cc');
                handleTemplateChange({ target: { value: '' } }, 'subject');
                setSubjectValue('');
            }
            setTemplateModified(false);
        }
    }, [templateSelection]);

    useEffect(() => {
      setTemplateModified(hasTemplateBeenModified());
      if (hasTemplateBeenModified()) {
        setParamSendMail({
              ...paramSendMail,
              cc: tags.cc,
              to: tags.to,
              subject: subjectValue,
              email_content: editorText
          })
      }
    }, [tags, subjectValue, editorText]);

    const handleTemplateSelection = (value: string) => {
      if (hasTemplateBeenModified()) {
        setNextTemplateSelection(value);
        setTemplateChangeConfirmation(true);
      } else {
        setTemplateSelection(value);
      }
    };

    const TemplateChangeDialog = () => (
      <Dialog open={templateChangeConfirmation} className="dialog-content">
        <DialogTitle id="leave-page-title" sx={{padding:'24px 24px 16px 24px'}}>
          <WarningIcon sx={{ margin: ' 0 16px -10px 0', fontSize: '35px', color: '#F29100'}} />
          <span style={{fontSize: '20px', fontWeight: 700}}>Reload email content</span>
          <IconButton
            aria-label="close"
            onClick={() => setTemplateChangeConfirmation(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{padding: '0 24px 24px 24px'}}>
          <DialogContentText id="leave-page-description" sx={{ fontSize: '16px', fontWeight: 500, color: '#212121' }}>
            You have unsaved changes. Are you sure you want to load new content?
            <br/><br/>
            All unsaved changes will be lost.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{padding: '0 24px 24px 24px'}}>
          <Button onClick={() => setTemplateChangeConfirmation(false)} variant="outlined" size={"large"}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              setTemplateSelection(nextTemplateSelection);
              setTemplateChangeConfirmation(false);
            }}
            variant="contained"
            size={"large"}
          >Load New Template</Button>
        </DialogActions>
      </Dialog>
    );

    const tagsChangeHandler = (type: string, newTags: string[]) => {
      setTags({ ...tags, [type]: newTags.map(tag => applyTokens(tag)) });
    }

    const handleEnterSearchInput = (event: any) => {
      event.stopPropagation();
      if (event.key === 'Enter') {
        setFilteredTemplates(filterSearchKeyword ? selectedTemplate : templates);
      }
    };

    const tokenClickHandler = (token: string) => {
      const toFocused = isActiveElement(tagRefTo?.current);
      const ccFocused = isActiveElement(tagRefCC?.current);
      const subjectFocused = isActiveElement(subjectRef?.current?.firstChild);
      const expandedToken = applyTokens(token);
      if (joditInstance?.editorIsActive) {
        joditInstance?.selection?.insertHTML(expandedToken);
        // @ts-ignore
        const newEditorText = joditInstance?.currentPlace?.element?.value
        setEditorText(newEditorText);
      } else if (subjectFocused) {
        insertTextAtCursor(subjectRef.current?.firstChild, expandedToken);
        setSubjectValue(subjectRef.current?.firstChild.value);
      } else {
        if (token === TEMPLATE_TOKENS.SENDER) {
          if (toFocused || ccFocused) {
            const tagsType = toFocused ? 'to' : 'cc';
            if (!tags[tagsType].includes(expandedToken)) {
              const newTags = [...tags[tagsType], expandedToken];
              setTags({ ...tags, [tagsType]: newTags });
            }
          }
        }
      }
    }

    const TokensComponent = () => {
      const tokenTagsScrollRef = useRef<HTMLDivElement | null>(null);
      const [leftDisabled, setLeftDisabled] = useState(true);
      const [rightDisabled, setRightDisabled] = useState(false);

      // Stable function to check scroll limits
      const updateDisabled = useCallback(() => {
        const el = tokenTagsScrollRef.current;
        if (!el) return;

        const { scrollLeft, scrollWidth, clientWidth } = el;
        setLeftDisabled(scrollLeft <= 0);
        setRightDisabled(scrollLeft + clientWidth >= scrollWidth);
      }, []);

      // Attach scroll listener only once
      useEffect(() => {
        const el = tokenTagsScrollRef.current;
        if (!el) return;

        updateDisabled(); // initial check
        el.addEventListener("scroll", updateDisabled);

        return () => {
          el.removeEventListener("scroll", updateDisabled);
        };
      }, [updateDisabled]);

      // Scroll buttons
      const handleScroll = (direction: "left" | "right") => {
        const el = tokenTagsScrollRef.current;
        if (!el) return;

        el.scrollBy({
          left: direction === "left" ? -200 : 200,
          behavior: "smooth",
        });

        // Ensure state is updated immediately (not just after smooth scroll finishes)
        requestAnimationFrame(updateDisabled);
      };

      return (<Stack className="tokens-component" gap={1} width="100%" marginBottom={3}>
        <Stack gap={2}>
          <Typography variant="body2">You can use these tokens in the <strong>To, CC, Subject,</strong> and <strong>Email
            Content</strong> fields. Click a token or type it directly into the field.
            <strong> Green</strong> tokens will display their value immediately</Typography>
        </Stack>
        <Stack direction="row">
          <Button
            variant="contained"
            className="tags-scroll-button"
            onClick={() => handleScroll('left')}
            disabled={leftDisabled}
          ><ArrowLeft/></Button>
          <Stack ref={tokenTagsScrollRef} gap={1} direction="row" alignItems="center" id="token-tags-scrollable">
            {tokens?.map((token, index) =>
              <TokenTag key={`token-${token.content}`} token={token.content} expandable={token.expandable}
                        clickHandler={tokenClickHandler} tooltip={token.tooltip}/>)}
          </Stack>
          <Button
            variant="contained"
            className="tags-scroll-button"
            onClick={() => handleScroll('right')}
            disabled={rightDisabled}
          ><ArrowRight/></Button>
        </Stack>
      </Stack>)
    };

    joditInstance?.events.on('keyup', (e) => {
      if (e.key === '}') {
        const sel = joditInstance.selection;
        const range = sel.range;

        if (!range.collapsed) return; // only when caret is not selecting

        const node = range.startContainer;
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.nodeValue;
          const pos = range.startOffset;

          // text up to cursor
          const before = text?.slice(0, pos) || '';

          // check if ends with {{...}}
          const match = before.match(/{{([^}]+)}}$/);
          if (match) {
            const replacement = applyTokens(match[0]);

            // update node
            node.nodeValue = before.replace(/{{[^}]+}}$/, replacement) + text?.slice(pos);

            // move cursor after inserted replacement
            const newPos = before.length - match[0].length + replacement.length;
            const newRange = document.createRange();
            newRange.setStart(node, newPos);
            newRange.collapse(true);

            sel.selectRange(newRange);
          }
        }
      }
    });

    return (
        <div className='form-body'>
            {scanResult[ 'scan-result' ] === 'Infected' ?
                <AlertMessage severity='error' content={MESSAGES_INFECTED_SENDMAIL}/> : null}
            <Grid container item xs={12} rowSpacing={1} className="" >
                {!isTestDomain ? <FromInputMail
                    validateFromName={validateFromName}
                    paramSendMail={paramSendMail}
                    fromNameError={fromNameError}
                    setParamSendMail={setParamSendMail}
                    setValidateFromName={setValidateFromName}
                    validateUserName={validateUserName}
                    setValidateUserName={setValidateUserName}
                    validateBaseSender={validateBaseSender}
                    setValidateBaseSender={setValidateBaseSender}
                /> : <Grid item xs={12} md={12}>
                    <InputLabel htmlFor="to-field" className='label-input' sx={{marginTop: '16px'}}>From </InputLabel>
                    <p style={{
                        display:"flex",
                        alignItems:"center",
                        fontSize: '14px',
                        fontWeight: 500,
                        fontFamily: 'Montserrat',
                        color: '#193051',
                        margin: 0,
                    }}>{testDomainName}
                    </p>
                </Grid>}
            </Grid>
            {useTemplates &&
                <>
                    <InputLabel className={'label-input'}>
                        Template List
                    </InputLabel>
                    <Select
                        name={'template-selection'}
                        value={templateSelection}
                        onChange={(e) => handleTemplateSelection(e.target.value)}
                        className={'template-input-select-field'}
                        IconComponent={(props) => (<ExpandMoreIcon {...props}/>)}
                        size={'small'}
                        onClose={() => setFilterSearchKeyword('')}
                        inputProps={{'data-testid': 'templateSelect'}}
                        MenuProps={{
                          MenuListProps: {
                            sx: {
                              maxHeight: 500,
                              maxWidth: 804,
                              overflowY: "auto",
                              overflowX: "hidden"
                            }
                          }
                        }}
                    >
                      {
                        templates.length > TEMPLATES_FILTER_ENABLE_LENGTH &&
                          <SearchFilter
                              height={38}
                              margin={'8px'}
                              titleInput={'Search By Keyword'}
                              iconSrc={Images.SearchIcon}
                              borderRadius={'4px'}
                              handleKeyDownEvent={handleEnterSearchInput}
                              inputValue={filterSearchKeyword}
                              setInputValue={setFilterSearchKeyword}
                          />
                      }
                        <MenuItem className="template-menu-item" key="template-empty" value={NO_TEMPLATE_VALUE}>
                            No template selected
                        </MenuItem>
                        <Divider style={{ margin: 0 }}/>
                        <div id="select-template">Select a template</div>
                          {
                            filteredTemplates.length ? filteredTemplates.map((template: any, index: number) => (
                              <MenuItem
                                className="template-menu-item"
                                key={`template-${index}`}
                                value={template['id']}
                              >
                                <Stack direction="row" gap={1.25}>
                                  <Box className={`template_type template_type_${template.type}`}>
                                    <span>{template.type ? `${template.type[0].toUpperCase()}${template.type.slice(1)}` : ''}</span>
                                  </Box>
                                  <Typography id="selected-template-name">
                                    {template.name}
                                  </Typography>
                                </Stack>
                              </MenuItem>
                            )) : <Box padding={1}><Typography variant="body2" textAlign="center" fontSize={12} fontStyle="italic" color="#666666" border="1px solid #EDEDED" borderRadius={0.5} padding={0.5}>All templates are currently inactive.<br/>
To activate or create a new one, please go to <strong>Settings</strong> and select <strong>Email Templates.</strong></Typography>
</Box>
                          }
                    </Select>
                    {templateModified && <Typography id="template-modified" variant="caption">{t('messages.templates.modified')}</Typography>}
                </>
            }
            <Grid container item xs={12} rowSpacing={1} className="email-contents">
              {useTemplates && <TokensComponent/>}
              {!isHiddenToCC && <>
                  <Grid item xs={12} md={12}>
                      <InputLabel htmlFor="to-field" className='label-input'>To <span style={{color:'#B00020'}}>*</span></InputLabel>
                      <TagInput tagRef={tagRefTo} type={TagInputTypes.TO} paramSendMail={paramSendMail}
                                setParamSendMail={setParamSendMail}
                                validateToField={validateToField}
                                setValidateToField={setValidateToField}
                                tags={tags.to} handleModifyTags={tagsChangeHandler}
                                inputValue={tagInputValues.to}
                                setInputValue={(value) => setTagInputValues((prev) => ({...prev, to: value}))}
                      />
                  </Grid>
                {!isTestDomain && <Grid item xs={12} md={12}>
                    <InputLabel htmlFor="cc-field" className='label-input'>CC</InputLabel>
                    <TagInput tagRef={tagRefCC} type={TagInputTypes.CC} paramSendMail={paramSendMail}
                              tags={tags.cc} handleModifyTags={tagsChangeHandler}
                              setParamSendMail={setParamSendMail} checkboxInput={checkboxInputCC}
                              inputValue={tagInputValues.cc}
                              setInputValue={(value: string) => setTagInputValues((prev) => ({...prev, cc: value}))}
                    />
                </Grid>}
              </>}
              <div style={{marginBottom: '24px', width: '100%'}}>
                <InputLabel htmlFor="subject" className='label-input'>Subject</InputLabel>
                {subjectPrefix ?
                  <OutlinedInput className='form-input input-prefix' type="text" placeholder='Enter subject'
                                 value={paramSendMail.subject} onChange={(e: any) => handleTemplateChange(e, 'subject')}
                                 style={{border: "unset"}}
                                 endAdornment={
                                   <InputAdornment position={"end"}>
                                     {subjectPrefix}
                                   </InputAdornment>}
                                 ref={subjectRef}
                                 id="outlined-adornment-weight"
                  /> :
                  <OutlinedInput id="subject" className='form-input' type="text" placeholder='Enter subject'
                                 ref={subjectRef}
                                 value={subjectValue}
                                 onChange={(e: any) => setSubjectValue(applyTokens(e.target.value))}
                                 onBlur={(_) => handleTemplateChange({target: {value: subjectValue}}, 'subject')}
                  />
                }
              </div>
              <InputLabel className='label-input'>Email Content <span style={{color:'#B00020'}}>*</span></InputLabel>
              <div style={{border: '1px solid #E0E0E0', borderRadius: '4px', padding: '16px', background: '#FFF', maxWidth: 738}}>
                <Editor paramSendMail={paramSendMail}
                        defaultContent={defaultContent}
                        editorError={editorError}
                        validateEmailContent={validateEmailContent}
                        setValidateEmailContent={setValidateEmailContent}
                        editorText={editorText}
                        setEditorText={setEditorText}
                        loadingEditor={loadingEditor}
                        templateEditorError={templateEditorError}
                        validateField={validateField}
                        isDisable={isDisable}
                        setIsDisable={setIsDisable}
                        isConfirm={isConfirm}
                        setIsConfirm={setIsConfirm}
                        joditInstance={joditInstance}
                        setJoditInstance={setJoditInstance}
                />
                {lineBelowContent && <hr style={{margin: '26px 0 12px 0', color: '#E0E0E0', borderStyle:'solid'}}/>}
              </div>
            </Grid>
            <TemplateChangeDialog />
        </div>
    )
}

